import { useMutation } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

interface ICreateCompetencyVariables {
  interview: string;
  name: string;
  type: string;
  createWithRubric: boolean;
}

interface ICreateCompetencyResponse extends ICreateCompetencyVariables {
  uid: string;
}

const useCreateCompetency = () => {
  const {
    mutateAsync: createCompetency,
    data,
    isLoading,
    error,
  } = useMutation<ICreateCompetencyResponse, Error, ICreateCompetencyVariables>(
    ['createCompetency'],
    async ({ name, type, interview, createWithRubric }) => {
      const body = {
        interview,
        name,
        type,
        create_with_rubric: createWithRubric,
      };

      const response = await fetchWithCsrfToken<ICreateCompetencyResponse>(
        `${PrependUrl.ASYNC}/competency/create`,
        'POST',
        body
      );

      return response;
    }
  );

  return {
    createCompetency,
    data,
    isLoading,
    error,
  };
};

export default useCreateCompetency;
